import { fetchPrimary } from "../environments/primary/fetch";

/** Shared transport mechanics; each World client validates its own response and refusal. */
export function postLocalJson(
  path: string,
  payload: unknown,
  fetchImpl: typeof fetch,
  signal?: AbortSignal,
): Promise<Response> {
  const transport = fetchImpl === fetch ? fetchPrimary : fetchImpl;
  return transport(path, {
    method: "POST",
    headers: { "content-type": "application/json" },
    credentials: "include",
    body: JSON.stringify(payload),
    ...(signal ? { signal } : {}),
  });
}

export async function decodeJsonObject(
  response: Response,
): Promise<Record<string, unknown> | null> {
  try {
    const value: unknown = await response.json();
    return typeof value === "object" && value !== null && !Array.isArray(value)
      ? (value as Record<string, unknown>)
      : null;
  } catch {
    return null;
  }
}
